import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SvgIcon from '../SvgIcon';
import Button from '../Button';

import './ResizableTextField.scss';

class ResizableTextField extends Component {
  static defaultProps = {
    rows: 6,
    value: '',
    dir: 'ltr'
  }

  constructor(props){
    super(props);
    this.state = {
      showMore: false
    }
  }

  componentDidMount() {
    let selectedTextarea = document.getElementById(this.props.id);
    if (selectedTextarea.scrollHeight >  selectedTextarea.clientHeight) {
      this.setState({ showMore: true})
    }
  }

  componentDidUpdate(prevProps) {
    let selectedTextarea = document.getElementById(this.props.id);
    if (this.props.id !== prevProps.id) {
      if (selectedTextarea.scrollHeight >  selectedTextarea.clientHeight) {
        this.setState({ showMore: true})
      }
      else{
        this.setState({ showMore: false})
      }
    }
  }

  handleOnFocus = (e) => {
    this.resize(e.target.id);
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  }

  handleOnBlur = (e) => {
    this.reset(e.target.id);
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  }

  handleOnChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  handleOnInput = (e) => {
    this.resize(e.target.id);
    if (this.props.onInput) {
      this.props.onInput(e);
    }
  }

  resize = (id) => {
    let selectedTextarea = document.getElementById(id);
    selectedTextarea.style.height = 'auto';
    // scrollHeight returns the entire height of an element, 
    // including the height that is not viewable (because of overflow)
    if (selectedTextarea.scrollHeight >  selectedTextarea.clientHeight) {
      this.setState({ showMore: false });
      selectedTextarea.style.height = selectedTextarea.scrollHeight + 'px';
    }
  }

  reset = (id) => {
    let selectedTextarea = document.getElementById(id);
    if (selectedTextarea.scrollHeight >  selectedTextarea.clientHeight) {
      selectedTextarea.style.height = 'auto';
      this.setState({ showMore: true })
    }
  }

  onPlusClick = (id) => {
    document.getElementById(id).focus();  
  }

  render() {
    const baseClassName = 'pb-resizable-text-field';
    const inputClassNames = [`${baseClassName}__textarea`];

    const {
      disabled,
      id,
      parentClassName,
      rows,
      value,
      name,
      dir
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--disabled`]: disabled,
      [parentClassName]: parentClassName
    }

    return (
      <div className={classNames(classes)}>
        <div className={`${baseClassName}__wrapper`}>
          <textarea
            className={inputClassNames.join(' ')}
            id={id}
            rows={rows}
            value={value}
            onChange={this.handleOnChange}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onInput={this.handleOnInput}
            disabled={disabled}
            name={name}
            dir={dir}
          />
        </div>
        { 
          this.state.showMore 
            ?
            <div className={`${baseClassName}__cue-btn`}>
              <Button
                label={<SvgIcon name="icon-plus" size="sm"/>}
                variant="primary-complement"
                greyBorder
                size="s"
                onClick={()=>{this.onPlusClick(id)}}
              />
            </div>
            :
            null
        }
      </div>
    );
  }
}

ResizableTextField.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onInput: PropTypes.func,
  parentClassName: PropTypes.string,
  rows: PropTypes.number,
  dir: PropTypes.string
};

export default ResizableTextField;



// WEBPACK FOOTER //
// ./src/components/ResizableTextField/ResizableTextField.jsx